<template>
    <div class="container text-center mb-5 pb-5">
        <h1 class="text-uppercase mt-5 mb-5" v-html="$t('Products.ProductsTitle')"></h1>
        <div class="row justify-content-center">
            <div v-for='pproduct in pproducts' :key='pproduct' class="col-md-3 mb-4">
                <p v-html="pproduct.img"></p>
                <p v-html="pproduct.title"></p>
            </div>
        </div>
    </div>
</template>
  
  <script>
export default {
  name: 'pp',
  data() {
    return {
      pproducts: [], // Initialize as an empty array
    };
  },
  created() {
    this.loadProducts(); // Load products when the component is created
  },
   watch: {
    '$i18n.locale': 'loadFaqs', // Reload FAQs when locale changes
  },
  methods: {
    async loadProducts() {
      try {
        // Fetch data from the JSON file in the public folder
        const currentLocale = this.$i18n.locale;
        const response = await fetch(`/locales/${currentLocale}.json`);
        const data = await response.json();

        // Check if data and the products array exist before assigning
        if (data && data.Products) {
          this.pproducts = data.Products.products;
        } else {
          console.error('Invalid product data structure in JSON file');
          this.pproducts = []; // Reset to empty array on error
        }
      } catch (error) {
        console.error('Error loading products:', error);
        this.pproducts = []; // Reset to empty array on error
      }
    },
  },
};
</script>
  